
function toggleSummaryBullets() {
    var bullets = document.querySelector('.ProductMeta__SummaryBullets'),
        button = document.querySelector('.ProductMeta__ReadMore');
    
    if (bullets) {
        if (bullets.querySelectorAll('li').length > 3) {
            var moreText = button.innerText,
                lessText = button.dataset.lessText;
    
            button.addEventListener('click', function() {
                this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true' );
                this.innerText = this.getAttribute('aria-expanded') === 'true' ? lessText : moreText;
                bullets.classList.toggle('ProductMeta__SummaryBullets--all');
            });
        } else {
            button.style.display = 'none';
        }
    }
}

function toggleVariantThumbnails() {
    document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant,
            targetOption = document.querySelector('.Product').dataset.changeImageOption;

        if (targetOption in variant) {
            var colorName = variant[targetOption].replace(/\s+/g, '').replace('/', '').toLowerCase(),
                variantSku = variant.sku.toLowerCase(),
                thumbs = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'),
                hasThumb = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage[data-image-variant="'+ colorName +'"]').length;
            
            if (hasThumb) {
                thumbs.forEach( function(thumb) {
                    if (colorName === thumb.dataset.imageVariant.toLowerCase() || variantSku === thumb.dataset.imageVariant.toLowerCase()) {
                        thumb.classList.remove('hidden-tablet-and-up');
                    } else {
                        thumb.classList.add('hidden-tablet-and-up');
                    }
                });
                toggleVariantDots(colorName, variantSku);
            } else {
                thumbs.forEach( function(thumb) {
                    thumb.classList.remove('hidden-tablet-and-up');
                });
                dots.forEach( function(dot) {
                    dot.classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
                })
            }
        }
    });
}

function toggleVariantDots(selectedColor, variantSku) {
    const productSlideshow = Flickity.data('.Product__Slideshow');
    if (productSlideshow) {
        var thumbs = document.querySelectorAll('.Product__SlideshowNavImage');
        var dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
        thumbs.forEach( function(thumb,i) {
            dots[i].dataset.color = thumb.dataset.imageVariant.toLowerCase();
            dots[i].dataset.imageVariant = thumb.dataset.imageVariant.toLowerCase();
            if(selectedColor === thumb.dataset.imageVariant.toLowerCase() || variantSku === thumb.dataset.imageVariant.toLowerCase()) {
                dots[i].classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
            } else {
                dots[i].classList.add('hidden-phone','hidden-tablet', 'hidden-lap');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    toggleSummaryBullets();
    toggleVariantThumbnails();
});